/**
 * 统一 API 根地址
 * - 本地调试 npm run serve：.env.development → http://127.0.0.1:8080
 * - 打包发布 npm run build：.env.production → https://api.qcwechat.cn
 */

export const PROD_API_BASE = 'https://api.qcwechat.cn'

export const DEV_API_BASE = 'http://127.0.0.1:8080'

function normalizeBase(url) {
  if (url == null || String(url).trim() === '') {
    return ''
  }
  return String(url).trim().replace(/\/+$/, '')
}

export const API_BASE_URL = normalizeBase(process.env.VUE_APP_API_BASE_URL)
  || (process.env.NODE_ENV === 'production' ? PROD_API_BASE : DEV_API_BASE)

/** 拼接接口路径，path 需以 / 开头 */
export function apiUrl(path) {
  const p = path.startsWith('/') ? path : `/${path}`
  return `${API_BASE_URL}${p}`
}
